import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=6f3ec0ba&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=ts"
export * from "./AboutUs.vue?vue&type=script&lang=ts"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=6f3ec0ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3ec0ba",
  null
  
)

export default component.exports